module.exports = __webpack_public_path__ + "static/media/08.19e71578.mp3";